module.exports = __webpack_public_path__ + "img/propuneri.09388440.svg";